import React from "react";

// assets
import TrendingImg from "src/assets/images/profile/trending.png";
import FireIcon from "src/assets/images/profile/Fire.svg";
import LocationIcon from "src/assets/images/profile/location.svg";
import CalenderIcon from "src/assets/images/profile/calender.svg";
import ShareIcon from "src/assets/images/profile/share.svg";
import BellIcon from "src/assets/images/profile/bell.svg";

// styles
import styles from "./styles.module.scss";

const Item = () => {
  return (
    <div className={styles.trending__item}>
      <div className={styles.img__section}>
        <img src={TrendingImg} alt="trending" />
        <button>Concert</button>
      </div>
      <div className={styles.info__section}>
        <div className={styles.item__upper}>
          <h3>New jersy Jackals at Ran...</h3>
          <span className={styles.tag}>
            <img src={FireIcon} alt="trending" />
            <span>Trending</span>
          </span>
        </div>
        <div className={styles.item__mid}>
          <span className={styles.icon__wrapper}>
            <img src={LocationIcon} alt="location" />
            <span>New Haven Museum sdv...</span>
          </span>
          <span className={styles.icon__wrapper}>
            <img src={CalenderIcon} alt="calender" />
            <span>Tonight 12:00 AM</span>
          </span>
        </div>
        <div className={styles.item__lower}>
          <button>
            <img src={BellIcon} alt="bell" />
            <span>Notify Me</span>
          </button>
          <img src={ShareIcon} alt="share" />
        </div>
      </div>
    </div>
  );
};

export default Item;
